<template>
  <KidHanziCardLayout :hide-role-image="face.style.hideRoleImage">
    <template #content>
      <DebutCardBadge
        v-if="face.isFirstLearn"
        class="absolute top-0 left-0"
      />

      <WrongCardBadge
        v-if="face.isWrongCard"
        class="absolute top-0 left-0"
      />

      <div class="text-96px">{{ face.card.hanzi[0]?.[1] }}</div>
    </template>

    <template #options>
      <p class="mb-2 text-ld-gray-text">
        {{ _t('cardview.kid_hanzi_card_need_parent') }}
      </p>
      <div class="operation-grid">
        <Button
          class="aspect-square"
          :scene="getOptionScene(true)"
          option
          @click="onSelect(true)"
        >
          <SparkleText
            class="sparkle-text"
            :tag="data.selected === true"
          >
            <div class="text-center">
              <div class="text-56px">😀</div>
              <div class="mt-6 font-bold text-20px text-ld-green">想起来了</div>
            </div>
          </SparkleText>
        </Button>

        <Button
          :scene="getOptionScene(false)"
          :class="{ wrong: data.selected === false, 'aspect-square': true }"
          option
          @click="onSelect(false)"
        >
          <SparkleText
            class="sparkle-text"
            :tag="false"
          >
            <div class="text-center">
              <div class="text-56px">😔</div>
              <div class="mt-6 font-bold text-21px text-ld-red">没想起来</div>
            </div>
          </SparkleText>
        </Button>
      </div>
    </template>
  </KidHanziCardLayout>
</template>

<script lang="ts" setup>
import { type KidHanziCardFace, UnitEventType } from '@/types/core'
import KidHanziCardLayout from '../../layout/KidHanziCardLayout.vue'
import { inject, reactive } from 'vue'
import { useHotKey } from '@/hooks'
import { FeedbackStar } from '../../common/feedback'
import { wait } from '@/utils/misc'
import DebutCardBadge from '@/components/ConcreteCard/common/DebutCardBadge.vue'
import WrongCardBadge from '../../common/WrongCardBadge.vue'
import SparkleText from '@/components/SparkleText.vue'
const { face } = defineProps<{
  face: KidHanziCardFace
}>()

const data = reactive({
  passed: false,
  selected: null as boolean | null,
})

useHotKey('1', (evt: KeyboardEvent) => {
  evt.preventDefault()
  onSelect(true)
})

useHotKey('2', (evt: KeyboardEvent) => {
  evt.preventDefault()
  onSelect(false)
})

function getOptionScene(
  v: boolean
):
  | 'choice'
  | 'choiceSelected'
  | 'choiceCorrect'
  | 'choiceWrong'
  | 'choiceUsed' {
  if (data.selected === v) {
    if (v) {
      return 'choiceCorrect'
    } else {
      return 'choiceWrong'
    }
  }
  return 'choice'
}

const onEvent = inject<(event: UnitEventType) => void>('onEvent')
const onStar = inject<(star: FeedbackStar) => void>('onStar')
const onNext = inject<VoidFunction>('onNext')

// 点击选项
function onSelect(value: boolean) {
  if (data.passed) return

  data.selected = value

  if (!value) {
    data.passed = true
    onEvent?.(UnitEventType.WRONG)
    onStar?.(FeedbackStar.One)
  } else {
    data.passed = true
    onStar?.(FeedbackStar.Three)
    onEvent?.(UnitEventType.CORRECT)
  }

  autoNext()
}

async function autoNext() {
  // TODO(buding): 如何准确获取动画结束，这里先 hardcode
  await wait(700)

  // 如果是新知识且设置的展示卡片详情，此时会先弹出卡片详情
  if (face.isFirstLearn && face.style.showCardDetail) {
    // showCardDetail(props.face.card, props.face.isFirstLearn, onNext)
    // return
  }

  onNext?.()
}
</script>

<style scoped></style>
